<template>
	<section class="itv-feedback-form" id="vacancies-form">
		<div class="itv-feedback-form__container">
			<h2 class="itv-feedback-form__title">
				{{ title }}
			</h2>
			<form v-if="render" :id="formCode" enctype="multipart/form-data">
				<input :value="formCode" type="hidden" name="code" />
				<input value="443595" type="hidden" name="form[JOB_EXTERNAL_ID]" />
				<div class="itv-feedback-form__list">
					<div class="itv-feedback-form__fieldset">
						<input-text
							:class="{ error: errors[fields.FIO.id] }"
							:placeholder="fields.FIO.placeholder"
							:label="fields.FIO.label"
							:name="fields.FIO.name"
							:type="fields.FIO.type"
							:id="fields.FIO.id"
							@change-value="fieldHandler"
						/>
						<error-text v-if="errors.FIO" :content="errors.FIO" />
					</div>
					<div class="itv-feedback-form__fieldset-wrap">
						<div class="itv-feedback-form__fieldset">
							<datepicker
								:class="{ error: errors[fields.BIRTHDAY.id] }"
								:min-date="minDate"
								:max-date="maxDate"
								:start-date="startDate"
								:name="fields.BIRTHDAY.name"
								@change-date="datepickerHandler"
							/>
							<error-text v-if="errors.BIRTHDAY" :content="errors.BIRTHDAY" />
						</div>
						<div class="itv-feedback-form__fieldset">
							<input-text
								:class="{ error: errors[fields.CITY.id] }"
								:placeholder="fields.CITY.placeholder"
								:label="fields.CITY.label"
								:name="fields.CITY.name"
								:type="fields.CITY.type"
								:id="fields.CITY.id"
								@change-value="fieldHandler"
							/>
							<error-text v-if="errors.CITY" :content="errors.CITY" />
						</div>
					</div>
					<div class="itv-feedback-form__fieldset-wrap">
						<div class="itv-feedback-form__fieldset">
							<input-text
								:class="{ error: errors[fields.EMAIL.id] }"
								:placeholder="fields.EMAIL.placeholder"
								:label="fields.EMAIL.label"
								:name="fields.EMAIL.name"
								:type="fields.EMAIL.type"
								:id="fields.EMAIL.id"
								@change-value="fieldHandler"
							/>
							<error-text v-if="errors.EMAIL" :content="errors.EMAIL" />
						</div>
						<div class="itv-feedback-form__fieldset">
							<input-text
								:class="{ error: errors[fields.TELEPHONE.id] }"
								:placeholder="fields.TELEPHONE.placeholder"
								:label="fields.TELEPHONE.label"
								:name="fields.TELEPHONE.name"
								:type="fields.TELEPHONE.type"
								:id="fields.TELEPHONE.id"
								@change-value="fieldHandler"
							/>
							<error-text v-if="errors.TELEPHONE" :content="errors.TELEPHONE" />
						</div>
					</div>
					<div class="itv-feedback-form__fieldset">
						<input-textarea
							:class="{ error: errors[fields.TEXT.id] }"
							:placeholder="fields.TEXT.placeholder"
							:label="fields.TEXT.label"
							:name="fields.TEXT.name"
							:id="fields.TEXT.id"
							@change-value="fieldHandler"
						/>
						<error-text v-if="errors.TEXT" :content="errors.TEXT" />
					</div>
					<div class="itv-feedback-form__fieldset">
						<input-upload
							@onFilesUploaded="fieldHandler"
							:max-files-size="fields.FILE.maxFilesSize"
							:max-files-length="fields.FILE.maxFilesLength"
							:max-one-file-size="fields.FILE.maxOneFileSize"
							:accept-file-extensions="fields.FILE.accept"
							:field-name="fields.FILE.name"
							:is-small="isMobile"
						/>
						<error-text v-if="errors.FILE" :content="errors.FILE" />
					</div>
					<div class="itv-feedback-form__fieldset">
						<input-term
							:class="{ error: errors[fields.TERM.id] }"
							:form-code="formCode"
							:value="fields.TERM.value"
							:id="fields.TERM.id"
							:name="fields.TERM.name"
							@change-value="fieldHandler"
							@show-term="termHandler"
						/>
						<error-text v-if="errors.TERM" :content="errors.TERM" />
					</div>
				</div>
				<div class="itv-feedback-form__submit">
					<primary-button :content="btnSubmit" @click-event="submitHandler">
						<template v-if="formSubmiting" #icon-left>
							<span
								class="itv-feedback-form__submit-preloader"
								aria-label="Отправка формы"
							></span>
						</template>
					</primary-button>
				</div>
				<div v-if="errorResponse.error" class="form-slider__response-error">
					<error-text :content="errorResponse.text" />
				</div>
				<div class="smartcaptcha" ref="smartcaptcha"></div>
			</form>
		</div>
	</section>
	<Transition>
		<modal-default
			v-if="showSuccess"
			:form-success="true"
			@hide-modal="
				() => {
					resetForm()
					forceRender()
					showSuccess = false
				}
			"
		>
			<template #content>
				<form-success
					:title="getSuccessModalData.title"
					:text="getSuccessModalData.text"
					:image="getSuccessModalData.image"
					@hide-modal="
						() => {
							resetForm()
							forceRender()
							showSuccess = false
						}
					"
				/>
			</template>
		</modal-default>
	</Transition>

	<Transition>
		<modal-default v-if="showTerm && policy" @hide-modal="showTerm = false">
			<template v-if="policy.name" #header>
				{{ policy.name }}
			</template>
			<template #content>
				<term :content="policy.props.text" />
			</template>
		</modal-default>
	</Transition>
</template>

<script>
import axios from 'axios'
import validateText from '@/js/modules/validate-text.js'
import validateEmail from '@/js/modules/validate-email.js'

import InputText from '../ui/InputText'
import InputTextarea from '../ui/InputTextarea'
import InputUpload from '../ui/InputUpload'
import InputTerm from '../ui/InputTerm'
import ErrorText from '../ui/ErrorText'
import PrimaryButton from '../ui/PrimaryButton'
import ModalDefault from '../ui/ModalDefault'
import Term from '../ui/Term'
import FormSuccess from '../ui/FormSuccess'
import Datepicker from '../ui/Datepicker'

import captchaMixin from '@/js/vue-components/mixins/captcha';

export default {
	name: 'FormDefault',
	components: {
		InputText,
		ErrorText,
		InputTextarea,
		InputUpload,
		InputTerm,
		PrimaryButton,
		ModalDefault,
		Term,
		FormSuccess,
		Datepicker,
	},
	mixins: [captchaMixin],
	data() {
		return {
			apiUrl: '/api/public/form/result/add/?code=career_vacancy',
			render: true,
			title: 'Откликнуться на вакансию',
			formCode: 'career_vacancy',
			submitBtnText: 'Отправить',
			formSubmiting: false,
			formSuccess: false,
			showSuccess: false,
			showTerm: false,
			modalContent: null,
			minDate: '',
			maxDate: new Date(),
			startDate: new Date(1990, 0),
			policy: null,
			fields: {
				FIO: {
					id: 'FIO',
					type: 'text',
					label: '',
					placeholder: 'ФИО',
					value: '',
					name: 'form[NAME]',
				},
				BIRTHDAY: {
					id: 'BIRTHDAY',
					name: 'form[BIRTHDAY]',
					value: '',
				},
				CITY: {
					id: 'CITY',
					type: 'text',
					label: '',
					placeholder: 'Город проживания',
					value: '',
					name: 'form[CITY]',
				},
				TELEPHONE: {
					id: 'TELEPHONE',
					type: 'tel',
					label: '',
					placeholder: '+7',
					value: '',
					name: 'form[TELEPHONE]',
				},
				EMAIL: {
					id: 'EMAIL',
					type: 'email',
					label: '',
					placeholder: 'Email',
					value: '',
					name: 'form[EMAIL]',
				},
				TEXT: {
					id: 'TEXT',
					type: 'textarea',
					label: '',
					placeholder: 'Расскажите о себе',
					value: '',
					name: 'form[DESCRIPTION]',
				},
				FILE: {
					id: 'FILE',
					value: '',
					name: 'form[FILE]',
					type: 'file',
					maxFilesSize: 10,
					maxFilesLength: 1,
					maxOneFileSize: 10,
					accept: '.pdf, .doc, .docx, .rtf, .html',
				},
				TERM: {
					id: 'TERM',
					value: '',
					name: 'form[agreement_id]',
					idPersPr: 's3',
				},
			},
			errors: {},
			errorResponse: {
				error: false,
				text: 'Попробуйте позже',
			},
			btnSubmit: {
				text: 'Отправить',
				btnColorType: 'green',
			},
		}
	},
	methods: {
		forceRender() {
			this.render = false
			this.$nextTick(() => {
				this.render = true
			})
		},

		resetForm() {
			Object.values(this.fields).forEach(el => (el.value = ''))
		},

		submitHandler() {
			if (!this.validateForm()) return
			this.sendForm()
		},

		fieldHandler(newVal, fieldId) {
			if (!fieldId) return

			if (this.errors[fieldId]) {
				this.errors[fieldId] = null
			}

			if (fieldId === 'TERM') {
				if (newVal) {
					this.fields.TERM.value = this.fields.TERM.idPersPr
					return
				}
				this.fields.TERM.value = ''
				return
			}

			this.fields[fieldId].value = newVal
		},

		validateForm() {
			this.errors = {}
			this.errorResponse.error = false

			if (!validateText(this.fields.FIO.value)) {
				this.errors[this.fields.FIO.id] = 'Обязательное поле'
			}

			if (!validateText(this.fields.TELEPHONE.value)) {
				this.errors[this.fields.TELEPHONE.id] = 'Обязательное поле'
			} else if (this.fields.TELEPHONE.value.length !== 17) {
				this.errors[this.fields.TELEPHONE.id] =
					'Введите корректный номер телефона'
			}

			if (!validateText(this.fields.EMAIL.value)) {
				this.errors[this.fields.EMAIL.id] = 'Обязательное поле'
			} else if (!validateEmail(this.fields.EMAIL.value)) {
				this.errors[this.fields.EMAIL.id] =
					'Укажите корректный адрес электронной почты'
			}

			if (!validateText(this.fields.TEXT.value)) {
				this.errors[this.fields.TEXT.id] = 'Обязательное поле'
			}

			if (!validateText(this.fields.CITY.value)) {
				this.errors[this.fields.CITY.id] = 'Обязательное поле'
			}

			if (!this.fields.BIRTHDAY.value) {
				this.errors[this.fields.BIRTHDAY.id] = 'Обязательное поле'
			}

			if (!this.fields.TERM.value) {
				this.errors[this.fields.TERM.id] = 'Примите согласие'
			}

			if (Object.values(this.errors).length === 0) {
				return true
			}
		},

		datepickerHandler(params, output) {
			if (this.errors.BIRTHDAY) {
				this.errors.BIRTHDAY = null
			}

			if (params && params.includes('/')) {
				this.fields.BIRTHDAY.value = params.replace('/', '.')
			}

			this.fields.BIRTHDAY.value = params
		},

		sendForm() {
			this.errorResponse.error = false
			this.errorResponse.text = 'Попробуйте позже'
			this.formSubmiting = true
			this.initCaptcha();
		},

		submitFormAfterCaptchaCheck() {
			const formData = new FormData(
					document.getElementById(this.formCode)
			)

			formData.delete('form[BIRTHDAY]')
			formData.append('form[BIRTHDAY]', this.fields.BIRTHDAY.value)

			axios({
				method: 'post',
				url: this.apiUrl,
				data: formData,
			})
				.then(response => {
					const { data } = response
					if (!data.success) {
						if (data.message) {
							this.errorResponse.text = data.message
						}

						this.errorResponse.error = true
						this.formSubmiting = false
						this.formSuccess = true
						this.showSuccess = true
						return
					}

					this.formSuccess = true
					this.showSuccess = true

					this.formSubmiting = false
				})
				.catch(error => {
					if (!error.response.data.success) {
						if (error.response.data.message) {
							this.errorResponse.text = error.response.data.message
						}
					}
					this.errorResponse.error = true
					this.formSubmiting = false
					this.formSuccess = true
					this.showSuccess = true
				})
		},

		termHandler() {
			if (this.policy) {
				this.showTerm = true
				return
			}

			axios
				.get(`/api/v2/content/policy/?code=${this.fields.TERM.idPersPr}`)
				.then(response => {
					const { data } = response
					this.policy = data.data
					this.showTerm = true
				})
		},
	},
	computed: {
		isMobile() {
			return window.innerWidth < 768
		},
		getSuccessModalData() {
			if (this.errorResponse.error) {
				return {
					title: 'Упс, что-то пошло не так',
					text: this.errorResponse.text,
					image: '/static/v2/src/img/it-vacancies/svg/alert.svg',
				}
			}

			return {
				title: 'Заявка отправлена',
				text: 'Ожидайте рассмотрения',
				image: '/static/v2/src/img/it-vacancies/svg/success.svg',
			}
		},
	},
	created() {
		if (this.isMobile) {
			this.fields.FILE.placeholder = 'Загрузите файлы'
		}
	},
}
</script>
